import { initializeApp } from 'firebase/app';
import { getAuth, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Replace with your Firebase project configuration
// You can find these values in your Firebase Console > Project Settings
const firebaseConfig = {

  apiKey: "AIzaSyCUlbO8pw4g970P07L5Lq8Uzm9PHhl26Vs",

  authDomain: "tnf-projects-portal.firebaseapp.com",

  projectId: "tnf-projects-portal",

  storageBucket: "tnf-projects-portal.firebasestorage.app",

  messagingSenderId: "808102352571",

  appId: "1:808102352571:web:819bfcb691b024ab917b9e",

  measurementId: "G-VR10D1Y8HN"

};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Email link authentication helpers
export { sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink };

export default app;
